/**
 * Single place where the GSAP plugins are registered, so every component
 * imports gsap from here rather than registering plugins repeatedly.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

/** The easing vocabulary used on augustus.com, in order of how often it appears. */
export const EASE = {
    /** Default for entrances and hovers. */
    out: 'power2.out',
    /** Text reveals and anything that should land hard. */
    reveal: 'power4.out',
    /** Loops and continuous motion. */
    inOut: 'power1.inOut',
    /** Scrubbed / linear motion. */
    none: 'none',
} as const;

export const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export { gsap, ScrollTrigger, SplitText };
